/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  TranslationsWebsite
} from './data.schemas'




export const getTranslations = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TranslationsWebsite>> => {
    
    return axios.default.get(
      `/api/segments/${encodeURIComponent(String(segmentationId))}/translations`,options
    );
  }


export const getGetTranslationsQueryKey = (segmentationId: number,) => {
    return [`/api/segments/${segmentationId}/translations`] as const;
    }

    
export const getGetTranslationsQueryOptions = <TData = Awaited<ReturnType<typeof getTranslations>>, TError = AxiosError<unknown>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTranslationsQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslations>>> = ({ signal }) => getTranslations(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof getTranslations>>>
export type GetTranslationsQueryError = AxiosError<unknown>

export const useGetTranslations = <TData = Awaited<ReturnType<typeof getTranslations>>, TError = AxiosError<unknown>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTranslationsQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetTranslations = async <TData = Awaited<ReturnType<typeof getTranslations>>, TError = AxiosError<unknown>>(
 queryClient: QueryClient, segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTranslationsQueryOptions(segmentationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


